module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.code == 0) ? _c('div', {
    staticClass: "success"
  }, [(_vm.novoCartao && _vm.usuario === null && _vm.validado === 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "success-box"
  }, [_c('h1', {
    staticClass: "bold"
  }, [_vm._v("Estamos quase lá!")]), _vm._v(" "), _c('h3', [_vm._v("Agora precisamos confirmar seu cartão de crédito.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "padding-l25"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Valor debitado (R$):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.valorDebitado),
      expression: "valorDebitado",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "mask-one-real",
      rawName: "v-mask-one-real"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.valorDebitado)
    },
    on: {
      "change": function($event) {
        _vm.valorDebitado = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.msgErro) ? _c('div', {
    staticClass: "alert alert-danger alert-margin",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.msgErro) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmCard()
      }
    }
  }, [_vm._v("\n              Confirmar valor\n              "), _c('i', {
    staticClass: "icon-tick align-icon-right-white"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger",
    attrs: {
      "to": {
        name: 'plans'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-cancel align-icon-left"
  }), _vm._v("\n              Agora não!\n            ")])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5)])]) : (_vm.newPix) ? _c('div', {
    staticClass: "welcome-box"
  }, [(!_vm.isMobile) ? _c('h2', {
    staticClass: "bold welcome",
    staticStyle: {
      "color": "#5d3b81"
    }
  }, [_vm._v("\n      Pagamento por Pix!\n    ")]) : _c('h2', {
    staticClass: "bold welcome",
    staticStyle: {
      "color": "#5d3b81",
      "font-size": "30px"
    }
  }, [_vm._v("\n      Pagamento por Pix!\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center",
      "margin-bottom": "50px"
    }
  }, [(_vm.pixCopiaCola) ? _c('qrcode-vue', {
    attrs: {
      "value": _vm.pixCopiaCola,
      "size": 250,
      "level": "H"
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticStyle: {
      "user-select": "none",
      "width": "250px",
      "padding": "8px",
      "background-color": "#f5f5f5",
      "overflow": "hidden",
      "white-space": "nowrap"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pixCopiaCola) + "\n      ")]), _vm._v(" "), (_vm.pixCopiaCola) ? _c('button', {
    staticClass: "btn btn-purple margin-5",
    class: {
      'btn-qr-copied': _vm.isQRCopied
    },
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "id": "qrcode",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyQRCodePix(_vm.pixCopiaCola)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.isQRCopied ? "Copiado" : "Copiar") + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "margin-t30"
  }, [_vm._v("\n      Após a conclusão do pagamento, você será notificado.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.isMobile) ? _c('router-link', {
    staticClass: "btn btn-purple margin-20",
    attrs: {
      "tag": "button",
      "to": {
        name: 'plans'
      },
      "type": "button",
      "name": "button"
    }
  }, [_vm._v("\n        Acessar minha conta\n        "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })]) : _c('router-link', {
    staticClass: "btn btn-purple margin-20",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "tag": "button",
      "to": {
        name: 'plans'
      },
      "type": "button",
      "name": "button"
    }
  }, [_vm._v("\n        Acessar minha conta\n        "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })])], 1), _vm._v(" "), _vm._m(6)]) : _c('div', {
    staticClass: "welcome-box"
  }, [(!_vm.isMobile) ? _c('h2', {
    staticClass: "bold welcome"
  }, [_vm._v("Parabéns!")]) : _c('h2', {
    staticClass: "bold welcome",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("Parabéns!")]), _vm._v(" "), (_vm.type == 'adhesion') ? _c('div', [_c('p', {
    staticClass: "bold no-margin"
  }, [_vm._v("Obrigado por nos escolher!")]), _vm._v(" "), _c('p', {
    staticClass: "margin-b30"
  }, [_vm._v("\n        Utilize os dados informados na sua adesão para acessar sua conta\n        (CPF/CNPJ e senha).\n      ")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "bold no-margin"
  }, [_vm._v("Fique atento!")]), _vm._v(" "), _c('p', {
    staticClass: "margin-b30"
  }, [_vm._v("\n      Para segurança de nossos clientes, não solicitamos informações de acesso\n      através de e-mail, WhatsApp, SMS ou qualquer outro meio.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.isMobile) ? _c('router-link', {
    staticClass: "btn btn-primary margin-20",
    attrs: {
      "tag": "button",
      "to": {
        name: 'plans'
      },
      "type": "button",
      "name": "button"
    }
  }, [_vm._v("\n        Acessar minha conta\n        "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })]) : _c('router-link', {
    staticClass: "btn btn-primary margin-20",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "tag": "button",
      "to": {
        name: 'plans'
      },
      "type": "button",
      "name": "button"
    }
  }, [_vm._v("\n        Acessar minha conta\n        "), _c('i', {
    staticClass: "icon-circle-right align-icon-right-white"
  })])], 1), _vm._v(" "), _vm._m(7)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-l25"
  }, [_c('p', {
    staticClass: "sub-title"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("1")]), _vm._v(" Consulte o valor exato debitado.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "sub-info"
  }, [_vm._v("\n            Realizamos um débito em sua fatura de baixo valor (inferior a R$\n            2,00), que será estornado posteriormente. Esse valor pode ser\n            verificado em sua fatura ou no aplicativo do seu cartão de\n            crédito.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sub-title"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("2")]), _vm._v(" Informando o valor debitado.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "sub-info"
  }, [_vm._v("\n            Caso já tenha em mãos o valor simbólico debitado em seu cartão de\n            crédito, informe no campo abaixo e confirme. Importante lembrar\n            que o pedido tem 48 horas para ser confirmado, caso contrário,\n            será\n            "), _c('span', [_vm._v("cancelado")]), _vm._v(".\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-l25 margin-t30"
  }, [_c('p', {
    staticClass: "sub-title"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("3")]), _vm._v(" Ainda não tenho o valor simbólico\n            debitado no cartão.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "sub-info"
  }, [_vm._v("\n            Caso não tenha em mãos o valor simbólico debitado em seu cartão de\n            crédito, você poderá informar o valor posteriormente. Importante\n            lembrar que o pedido tem 48 horas para ser confirmado, caso\n            contrário, será cancelado.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            Para sua segurança, certifique-se de que as informações e valores\n            estão corretos. Após a efetivação de sua compra, você receberá um\n            e-mail com todas as informações para a ativação do seu contrato.\n            Em caso de dúvidas, entre em contato com nossa\n            "), _c('b', [_vm._v("Central de Relacionamento")]), _vm._v(".\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade bs-example-modal-sm modal-success-adhesion",
    attrs: {
      "id": "modalSuccessAdhesion",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "successAdhesionLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content text-center"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "successAdhesionLabel"
    }
  }, [_vm._v("\n                Compra realizada com sucesso!\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('h4', [_vm._v("Seja bem vindo(a) a Move Mais!")]), _vm._v(" "), _c('img', {
    staticClass: "margin-10",
    attrs: {
      "src": "/static/Icon-check-circle.svg",
      "alt": "icon-check-circle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                OK\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "margin-t30"
  }, [_vm._v("\n      Em caso de dúvida entre em contato com a nossa\n      "), _c('b', [_vm._v("Central de Relacionamento")]), _vm._v(":\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "margin-t30"
  }, [_vm._v("\n      Em caso de dúvida entre em contato com a nossa\n      "), _c('b', [_vm._v("Central de Relacionamento")]), _vm._v(":\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-73458ad8!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/adhesion/success.vue
// module id = 2168
// module chunks = 1